<template>
  <navbar :show-navbar="showNavbar" style="background-color: #2a5788 !important;">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
    </div>
    <button @click="toggleNavbar" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navigation"
            aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">

     <!-- <oci-notifications></oci-notifications>-->
      <ul class="navbar-nav">
         <li class="nav-item" v-if="$isAllowed('viewAdminDashboard')">
          <a class="nav-link" href="/admin">
            Admin
            <i class="fa fa-2x fa-user-secret"></i>
            <p>
              <span class="d-lg-none d-md-block">Admin</span>
            </p>
          </a>
        </li>


       <!-- <li class="nav-item">
          <a class="nav-link" href="/pages/user">

            <i class="now-ui-icons users_single-02"></i>

            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>-->

        <!--<li class="nav-item">
          <a class="nav-link" @click="handleNotificationsIconClick">
            <i  class="fa fa-bell  "></i>

            <p>
              &lt;!&ndash;  TODO - add check for recent notifications all subscribed - viewed , use a getter  &ndash;&gt;
              <span ><sup  v-if="subscribedNotificationsAvailable" class="oc-notifications-alert-count">{{subscribedNotificationsLength}}</sup></span>

              <span class="d-lg-none d-md-block">Notifications</span>
            </p>
          </a>

        </li>-->
        <!--<li class="nav-item">
          <a class="nav-link"   @click="handleChatIconClick">
            <i class="fa fa-comments "></i>
            <p>

              <span v-if ="messageArrived" class="oc-chat-message-arrived ">*</span>
              <span class="d-lg-none d-md-block">Chat Messages</span>
            </p>
          </a>

        </li>-->
        <li class="nav-item" v-if="!this.$store.getters.tokenPresent">
          <a class="nav-link"  @click="signIn">
            Sign In
            <i class="fa fa-sign-in" aria-hidden="true"></i>
            <p>
              <span class="d-lg-none d-md-block">Sign In</span>
            </p>
          </a>
        </li>
        <li class="nav-item" v-if="this.$store.getters.tokenPresent">
          <a class="nav-link"  @click="signOut">
            Sign Out
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            <p>
              <span class="d-lg-none d-md-block" style="z-index: 9">Sign Out</span>
            </p>
          </a>
        </li>
      </ul>

    </template>
  </navbar>

</template>
<script>
  import {RouteBreadCrumb, Navbar, NavbarToggleButton} from '@/common/components/index';
  import {CollapseTransition} from 'vue2-transitions'
  import OciNotifications from '@/common/components/notifications/OciNotifications.vue'
  import * as perimeters from '@/perimeters';

  export default {
    components: {
      RouteBreadCrumb,
      Navbar,
      NavbarToggleButton,
      CollapseTransition,
      OciNotifications
    },
    perimeters: [
      perimeters.ociPerimeters
    ],
    computed: {
      routeName() {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name)
      },
      subscribedNotificationsAvailable:{
        get(){
          if(this.$store.getters.subscribedNotifications){
            let subscribedNotifications = this.$store.getters.subscribedNotifications;
            return (subscribedNotifications.length>0)
          }else{
            return false;
          }
        }
      },
      subscribedNotificationsLength: {
        get(){
          if(this.$store.getters.subscribedNotifications){
            return this.$store.getters.subscribedNotifications.length;
          }else{
            return 0;
          }
        }
      }
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        messageArrived:true,
        received_messages: [],
        send_message: null,
        connected: false,
        chatMessages:[],
        chatId:0,
        chatMessage: {
          username: '',
          sentTime: '',
          receivedTime: '',
          chatId: 0,
          content: '',
          sender: '',
          recipients: [],
          createdFromEpoch: 0,
          brokeredFromEpoch: 0
          }
        }
    },

    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      signOut(){
        this.$store.dispatch("revokeToken");
        window.location.replace('/auth/login');
      },
      signIn(){
        window.location.replace('/auth/login');
      },

      //chat related handlers
      //handle chat icon click
      handleChatIconClick(){
        this.$parent.showRightChatArea();
      },
      handleNotificationsIconClick(){
        this.$parent.showNotificationsViewArea();
      },
    },
    mounted(){
     }
  }

</script>
<style>
  .oc-chat-message-arrived{
    color:red;
    font-size: 2em;
  }
  .oc-notifications-alert-count{
    color:red;
    font-size: 1.1em;

  }
</style>
